import { WithList, WithPagination } from '@bv/api/crud';
import { mixinClass } from '@bv/utils';

class CustomAttributesApi extends mixinClass(WithList<CustomAttributeItem>, WithPagination<CustomAttributeItem>) {
  public constructor(public endpoint = 'contacts/custom-attributes') {
    super(endpoint);
  }
}

export const customAttributesApi = new CustomAttributesApi();
